<template>
  <!-- TODO check src/views/my/order/OrderHistory.vue:1 -->
  <div id="order-history-page" v-cloak>
    <VBlock class="order-history">
      <LoadingContainer :isShow="isLoading" />
      <!-- <EmptyOrdersContainer /> -->
      <EmptyOrdersContainer v-if="isEmptyOrders" />
      <VBlock v-else class="page-wrapper" :direction="Direction.column" :sort="Sort.left_center">
        <OrderHistoryBanner />
        <InProgressOrdersContainer />
        <NotInProgressOrdersContainer />
      </VBlock>
    </VBlock>
  </div>
</template>

<script>
import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'

import LoadingContainer from '@/presentationals/v2/components/containers/LoadingContainer'
import InProgressOrdersContainer from '@/presentationals/v2/components/containers/InProgressOrdersContainer'
import NotInProgressOrdersContainer from '@/presentationals/v2/components/containers/NotInProgressOrdersContainer'
import EmptyOrdersContainer from '@/presentationals/v2/components/containers/EmptyOrdersContainer'
import OrderHistoryBanner from '@/presentationals/v2/components/containers/OrderHistoryBannerContainer'

import { GlobalFunctionName, setGlobalFunction } from '@/utils/nativeBridge'

import { Action, MoveType, Location } from '@/plugins/AppManager'
import { NativeStorageKey } from '@/plugins/NativeStorageManager'

import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'

export default {
  name: 'OrderHistoryPage',
  components: {
    LoadingContainer,
    EmptyOrdersContainer,
    NotInProgressOrdersContainer,
    InProgressOrdersContainer,
    OrderHistoryBanner,
    VBlock
  },
  data() {
    return {
      Direction,
      Sort,

      isLoading: true
    }
  },
  computed: {
    isEmptyOrders() {
      return this.$store.getters['myOrderHistoryV2/isEmptyOrders']
    }
  },

  async created() {
    setGlobalFunction(
      GlobalFunctionName.ON_BAEMIN_WEB_VIEW_WILL_APPEAR,
      this.onBaeminWebViewWillAppear
    )

    // const isGoToBmartFlag = await this.$nativeStorageManager.get(NativeStorageKey.GO_TO_BMART_FLAG)

    // if (isGoToBmartFlag === 'true') {
    //   await this.$nativeStorageManager.set(NativeStorageKey.GO_TO_BMART_FLAG, 'false')
    //   this.$appManager.move(
    //     Location.HISTORY_TO_SHOP,
    //     this.$store.getters.isAndroid,
    //     MoveType.REPLACE,
    //     {
    //       market_cartToolTip: false
    //     }
    //   )
    // }

    // const isGoToHomeFlag = await this.$nativeStorageManager.get(NativeStorageKey.GO_TO_HOME_FLAG)

    // if (isGoToHomeFlag === 'true') {
    //   await this.$nativeStorageManager.set(NativeStorageKey.GO_TO_HOME_FLAG, 'false')
    //   this.$appManager.move(Location.HOME)
    // }

    // 페이지 더미 쿼리스트링
    // ?isUpdate=true&appVersion&signed=true&baeminShopNo=10662330&key=SjVYMlRkZWI0SDFtY0VnZmluQ2p1Ny9SSTNmWHNOTGhoV2FZNkZ2ZmdGYkgyWGdaSC9IL0J2WmdYNUh4bEpNeC9iL1YyOFVybHJzcDFhb3A0OEFBRWhDczdCMUxTQ0Q4L2dOSG5MSkE1bEJZWm5ROG5rTDBlVXNvZ0VLRlJpUEo3TFcrbFBOQmJlNzJWMjNsOC9nZWZJTi9oT2JqR3BPK25EaHhVYkpVR21Tb2wvaW1MOUxkQ0VMSE5KbkduZ09s%3D%3D&
    // const { isUpdate, appVersion, key, signed, baeminShopNo } = {
    //   isUpdate: 'true',
    //   appVersion: '1.1.1',
    //   key: 'SjVYMlRkZWI0SDFtY0VnZmluQ2p1Ny9SSTNmWHNOTGhoV2FZNkZ2ZmdGYkgyWGdaSC9IL0J2WmdYNUh4bEpNeC9iL1YyOFVybHJzcDFhb3A0OEFBRWhDczdCMUxTQ0Q4L2dOSG5MSkE1bEJZWm5ROG5rTDBlVXNvZ0VLRlJpUEo3TFcrbFBOQmJlNzJWMjNsOC9nZWZJTi9oT2JqR3BPK25EaHhVYkpVR21Tb2wvaW1MOUxkQ0VMSE5KbkduZ09s',
    //   signed: 'true',
    //   baeminShopNo: '10662330'
    // }

    // TODO check src/views/my/order/OrderHistory.vue:38
    const { isUpdate, appVersion, signed, sessionId } = this.$route.query
    if (this._.isString(isUpdate)) {
      this.$store.commit('myOrderHistoryV2/setIsUpdate', isUpdate === 'true')
    }
    this.$store.commit('myOrderHistoryV2/setAppVersion', appVersion)
    this.$store.commit('setSignedUser', signed !== null ? signed === 'true' : false)
    this.$store.commit('setSessionId', sessionId)

    this.isLoading = true

    const result = await this.$store.dispatch('myOrderHistoryV2/loadInProgressOrders')

    // console.log(result)

    if (result.code === '401' || result.code === '500') {
      this.isLoading = false
      this.$store.dispatch('modal/open', {
        // Modal Open
        type: 'Check',
        message: result.message,
        onOK: async () => {
          // window.location.href = 'baemin-action-beta://refreshToken'

          // setTimeout(() => {
          //   window.location.href = 'baemin-beta://home/orderHistory?orderHistory_type=market'
          // }, 150)
          this.$appManager.action(Action.REFRESH_TOKEN)

          if (this.$store.getters.isAndroid) {
            this.$appManager.move(Location.HOME)
            return
          }

          setTimeout(() => {
            this.$appManager.move(
              Location.ORDER_HISTORY,
              this.$store.getters.isAndroid,
              MoveType.REPLACE,
              {
                orderHistory_type: 'market'
              }
            )
          }, 150)

          this.$store.dispatch('modal/close')
        },
        onCancel: async () => {}
      })

      return
    }

    await this.$store.dispatch('myOrderHistoryV2/loadChatbot')

    await this.$store.dispatch('myOrderHistoryV2/loadNotInProgressOrderPage')

    this.refreshOrderBadge()

    const { baeminMemberId: memberId, baeminMemberNo: memberNo, deviceId } = this.$store.getters

    this.$appLogManager.init({
      memberId,
      memberNo,
      sessionId,
      deviceId,
      appVersion
    })

    const { ref } = this.$store.getters

    // M4
    this.$appLogManager.post({
      screenName: LogScreenName.MARKET_ORD_HIST,
      type: LogType.VIEW,
      params: { ref }
    })

    this.isLoading = false
  },
  methods: {
    async onBaeminWebViewWillAppear() {
      const deletedOrderId = await this.$nativeStorageManager.get(
        NativeStorageKey.BAEMIN_MARKET_DELETED_ORDER_ID
      )
      await this.refreshOrderHistory(deletedOrderId)

      window.location = `${process.env.VUE_APP_PROXY_API_URL}/v1/orders/relay/my/history`
    },
    async refreshOrderHistory(deletedOrderId) {
      if (_.isEmpty(deletedOrderId)) return

      await this.$nativeStorageManager.remove(NativeStorageKey.BAEMIN_MARKET_DELETED_ORDER_ID)
      this.isLoading = true
      await Promise.all([
        this.$store.dispatch('myOrderHistoryV2/loadInProgressOrders', true),
        this.$store.dispatch('myOrderHistoryV2/loadNotInProgressOrderPage', true)
      ])
      this.isLoading = false
    },
    refreshOrderBadge() {
      // TODO check src/components/my/order/Delivering.vue:47
      // TODO vuex 로직으로 이동?
      const list = this.$store.getters['myOrderHistoryV2/inProgressOrders'] || []

      const showOrderBadgeParams = list.map(e => e.toShowOrderBadgeParam)
      this.$appManager.action(Action.ORDER_BADGE, MoveType.PUSH, {
        showOrderBadge_ordType: 'market',
        showOrderBadge_ords: `[${showOrderBadgeParams.join(',')}]`
      })

      // const badgeUrl = process.env.VUE_APP_ORDER_BADGE_URL
      // const queryString = `showOrderBadge_ordType=market&showOrderBadge_ords=[${showOrderBadgeParams.join(
      //   ','
      // )}]`
      // window.location.href = `${badgeUrl}?${queryString}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

#order-history-page {
  background-color: $background-gray;
  .order-history {
    .page-wrapper {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
}
</style>
